// extracted by mini-css-extract-plugin
export default {"flightTimes":"flightTimes__1fA0j"};